import { AlertModalContext } from "context/AlertModalContext";
import { useContext } from "react";

function useAlertModal() {
  const { setShowAlertModal, setAlertProps } = useContext(AlertModalContext);

  const alert = ({ text, button, onClose, variant }) => {
    setShowAlertModal(true);

    setAlertProps({
      text,
      button,
      onClose,
      variant,
    });
  };

  return alert;
}

export default useAlertModal;
